export class PrimeCookies {
  access_token: string;
  session_token: string;
  Nonce: string;
}
